import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-car-insurance-product',
  imports: [FormsModule,CommonModule,TranslatePipe],
  templateUrl: './car-insurance-product.component.html',
  styleUrl: './car-insurance-product.component.scss'
})
export class CarInsuranceProductComponent {
  activeIndex = 0;

  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef<HTMLDivElement>;

  /**
   * List of insurance products to display
   */
  insurances = [
    {
      title: 'Motorbike Insurance',
      description: 'Compliance and financial support for accidents, with flexible upgraded options',
      btnText: 'BUY NOW',
      btnType: 'primary',
      btnLink: 'https://www.livwell.vn/motor-bike-insurance',
      img: '/png/bike-Small.png',
    },
    {
      title: 'Gymer Insurance',
      description: 'Tailored financial shield for gym accidents & workout medical needs',
      btnText: 'BUY NOW',
      btnType: 'primary',
      btnLink: 'https://www.livwell.vn/gym-insurance',
      img: '/png/GYM-PA-Small.png',
    },
    {
      title: 'Personal Accident Insurance',
      description: 'Financial shield for unexpected accidents. Covers treatment & critical support',
      btnText: 'BUY NOW',
      btnType: 'primary',
      btnLink: 'https://www.livwell.vn/personal-accident-insurance',
      img: '/png/PA-Small.png',
    },
  ];

  /**
   * Scrolls horizontally to the selected card index
   */
  setActive(index: number) {
    this.activeIndex = index;

    if (this.scrollContainer) {
      const container = this.scrollContainer.nativeElement;
      const cardWidth = container.offsetWidth * 0.8; // slight overlap visibility
      container.scrollTo({
        left: cardWidth * index,
        behavior: 'smooth',
      });
    }
  }

  /**
   * Updates active index based on scroll position (for highlighting dots)
   */
  @HostListener('window:resize')
  ngAfterViewInit() {
    if (this.scrollContainer) {
      this.scrollContainer.nativeElement.addEventListener('scroll', () => this.updateActiveIndex());
    }
  }

  updateActiveIndex() {
    if (!this.scrollContainer) return;
    const container = this.scrollContainer.nativeElement;
    const scrollLeft = container.scrollLeft;
    const cardWidth = container.offsetWidth * 0.8;
    const newIndex = Math.round(scrollLeft / cardWidth);
    if (newIndex !== this.activeIndex) {
      this.activeIndex = newIndex;
    }
  }

}
